<template>
  <div class="filter-feature-2">
    <form @submit.prevent="submitForm">
      <div class="row align-items-center">

        <template v-for="(item,index) in features">
          <div class="col-12 mb-2">
            <SingleFeature @selectedItem="selectedItemManager(index, $event)" :feature="item.feature"
                           :feature-attributes="item.attributes"/>
          </div>
        </template>

        <div class="col-12">
          <button class="btn btn-primary d-inline-block">جست وجو</button>
        </div>

      </div>
    </form>
  </div>

</template>

<script>
import SingleFeature from "./SingleFeature.vue";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "FilterFeature2",
  components: {SingleFeature},
  props: {
    featuresId: {
      default: [],
      type: Object,
    },
    filterRoute: {
      default: 'Products',
    },
  },
  data() {
    return {
      features: [],
      selectedItems: []
    }
  },
  methods: {
    async getFeature() {

      for (const item of this.featuresId) {
        let featureData = await this.$store.dispatch('Feature/getSingleFeatureWithoutAuthentication', {id: item})
        this.features.push(featureData.data.data)
      }

    },
    submitForm() {

      let selectedIds = this.selectedItems.map(item => item.id).join(',')

      let routeData = this.$router.resolve({name: this.filterRoute, query: {features: selectedIds}});
      window.open(routeData.href, '_blank');

    },
    selectedItemManager(index, data) {
      this.selectedItems[index] = data
      if (this.selectedItems.length == this.featuresId.length) {
        this.submitForm()
      }
    }
  },
  async mounted() {
    this.$store.commit("Product/setFilters", {key: "feature_operator", value: 'and'})
    await this.getFeature();
  },
  destroyed() {
    this.$store.commit("Product/setFilters", {key: "feature_operator", value: 'or'})
  }
}
</script>


<style scoped>

</style>